import PlayIcon from '@/components/SvgIcon/Icons/Play.vue';
import YoutubePlayIcon from '@/components/SvgIcon/Icons/YoutubePlay.vue';
export default {
  play: PlayIcon,
  'youtube-play': YoutubePlayIcon
};
